import React from 'react'

const SearchOverlayButton = ({ on, ...props}) => {
    const isExpanded = on ? true : false
    
    return (
        <div
        aria-label="Toggle search overlay"
        aria-expanded={isExpanded}
        {...props}
        >   
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 20 20"
                className="fill-current"
            >
                <title>search</title>
                <path d="M19 17l-5.15-5.15a7 7 0 1 0-2 2L17 19zM3.5 8A4.5 4.5 0 1 1 8 12.5 4.5 4.5 0 0 1 3.5 8z" />
            </svg>
        </div>
    )
}

export default SearchOverlayButton